import { motion } from 'motion/react';
import { Check } from 'lucide-react';

interface MaterialSection {
  title: string;
  items: string[];
}

interface MaterialsOptionsProps {
  materials: MaterialSection[];
}

export function MaterialsOptions({ materials }: MaterialsOptionsProps) {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold mb-4">Materials & Options</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Premium glass and hardware selections to match your style
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {materials.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white/80 backdrop-blur-sm border border-border rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <h3 className="mb-4 pb-3 border-b border-border">{section.title}</h3>
              <ul className="space-y-3">
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-2">
                    <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
